export default "__VITE_ASSET__f54b281b__"